module.exports = __webpack_public_path__ + "static/media/click-here-button.6684f451.png";